import {
  useInfiniteQuery,
  useMutation,
  useQuery,
  useQueryClient,
} from '@tanstack/react-query';
import { useDispatch } from 'react-redux';
import { markMenuBulkUnsaved } from 'redux/actions/Menu/markMenuBulk';
import * as api from '../api/bulk-import';

/** Past import runs, newest first. */
export const useBulkImportsPaginated = (params) =>
  useInfiniteQuery({
    queryKey: ['bulk-imports', 'paginated', params],
    queryFn: ({ pageParam = 1 }) =>
      api.getBulkImportsPaginated({ ...params, page: pageParam }),
    getNextPageParam: (lastPage) =>
      lastPage.page < lastPage.totalPages ? lastPage.page + 1 : undefined,
    initialPageParam: 1,
    placeholderData: (prev) => prev,
  });

export const useBulkImport = (uuid) =>
  useQuery({
    queryKey: ['bulk-imports', uuid],
    queryFn: () => api.getBulkImport(uuid),
    enabled: !!uuid,
  });

export const useBulkImportItems = () => {
  const qc = useQueryClient();
  const dispatch = useDispatch();
  return useMutation({
    mutationFn: (data) => api.importInventoryItems(data),
    onSuccess: () => {
      // An import creates items and moves stock, so every cached inventory view
      // is stale afterwards.
      qc.invalidateQueries({ queryKey: ['products'] });
      qc.invalidateQueries({ queryKey: ['ingredients'] });
      qc.invalidateQueries({ queryKey: ['inventory-lots'] });
      qc.invalidateQueries({ queryKey: ['transactions'] });
      qc.invalidateQueries({ queryKey: ['bulk-imports'] });
      // Creating/updating items leaves provider menus out of date. Mark the
      // menu unsaved so "Update Provider Menus" enables without a refresh.
      dispatch(markMenuBulkUnsaved());
    },
  });
};
